import { WizCommand } from '@wizeoo/akm-component-lib';
import { VisionVO} from '@wizeoo/akm-compute-lib';
import { VisionStat } from '@wizeoo/akm-message-lib';
import { VISION_PROPERTY } from '../../model/enums';
import { Model } from '../../model/model';
import { ExternalAPI } from '../../model/external-api';

/**
 * Appels du service de génération de lignes de vision
 * Author LMA
 */
export class VisionStatsCmd extends WizCommand<VisionStat> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }

  public vo: VisionVO = null; // la vision porteuse des lignes à alimenter

  public do(vision: VisionVO, callback: Function): VisionStatsCmd {
    this.vo = vision;

    this.configureRemote(ExternalAPI.VISION_STATS, this.vo.source, callback);
    return this;
  }

  /** sur retour, traitement selon la méthode */
  public wizResult() {
    const stats: VisionStat = this.result;
    this.model.visionEngine.setVisionProperties(this.vo, VISION_PROPERTY.METRICS, stats);

    super.wizResult();
  }

}
